import { useSuspenseQuery } from '@tanstack/react-query';
import { getListInterviewTypesQueryOptions } from '@sara/api-client';
import { InterviewTypeList } from '../../components/InterviewTypeList';
import { toSuspense } from '../../../../lib/query';
import { useOrgSlug } from '../../../auth';
import type { InterviewTypeListContainerProps } from './types';

export function InterviewTypeListContainerContent({ orgId }: InterviewTypeListContainerProps) {
  const { data } = useSuspenseQuery(toSuspense(getListInterviewTypesQueryOptions({ orgId })));
  const orgSlug = useOrgSlug();

  return (
    <InterviewTypeList
      interviewTypes={data}
      getLinkProps={(type) => ({
        to: '/orgs/$orgSlug/templates/$interviewTypeId',
        params: { orgSlug, interviewTypeId: type.id },
      })}
    />
  );
}
